import { useState } from "react";
import { Phone, Menu, X, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

const WHATSAPP_URL = "https://wa.me/919891315777?text=Hi%2C%20I%20want%20to%20book%20a%20water%20tank%20cleaning%20service%20in%20Gurugram";
const LOGO_URL = "https://customer-assets.emergentagent.com/job_tankbuddy-gurgaon/artifacts/he99wde0_Gemini_Generated_Image_kjnrs1kjnrs1kjnr.png";

const navLinks = [
  { label: "Services", href: "/services" },
  { label: "About", href: "/about" },
  { label: "Blog", href: "/blog" },
  { label: "Process", href: "/#process" },
  { label: "Pricing", href: "/#pricing" },
  { label: "Contact", href: "/#contact" },
];

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header
      data-testid="header"
      className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-xl border-b border-slate-200/50 shadow-sm"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-18">
        <a href="/" className="flex items-center" data-testid="header-logo">
          <img
            src={LOGO_URL}
            alt="TankBuddy - Premium Water Tank Cleaning"
            className="h-10 md:h-12 w-auto"
          />
        </a>

        <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm font-medium text-slate-600 hover:text-navy transition-colors duration-200"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Button
            asChild
            data-testid="header-whatsapp-btn"
            className="bg-whatsapp hover:bg-whatsapp-hover text-white rounded-full px-5"
          >
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
              <MessageCircle className="w-4 h-4 mr-2" />
              WhatsApp Us
            </a>
          </Button>
          <Button
            asChild
            data-testid="header-call-btn"
            className="bg-navy hover:bg-navy-light text-white rounded-full px-5"
          >
            <a href="tel:+919891315777">
              <Phone className="w-4 h-4 mr-2" />
              Call Now
            </a>
          </Button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2 text-navy"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-white/95 backdrop-blur-xl border-b border-slate-200 animate-fade-in"
        >
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-base font-medium text-slate-700 hover:text-navy py-2"
                onClick={() => setMobileOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <Button
              asChild
              className="bg-whatsapp hover:bg-whatsapp-hover text-white rounded-full mt-2"
            >
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
                <MessageCircle className="w-4 h-4 mr-2" />
                WhatsApp Us
              </a>
            </Button>
            <Button
              asChild
              className="bg-navy hover:bg-navy-light text-white rounded-full"
            >
              <a href="tel:+919891315777">
                <Phone className="w-4 h-4 mr-2" />
                Call Now
              </a>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
